import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';

/**
 * Fetches model from backend
 */
@Injectable({
  providedIn: 'root',
})
export class SupplierUserPositionService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  public getUserPositions(): Observable<string[]> {
    return this.http.get<string[]>(
      this.urlHelper.prepareApiPath('user-positions'),
    );
  }
}
